import { Component } from "@angular/core";
import { WorkFlowCreatorNodeType } from "../../webhook-types/workflow-creator-node-type";
import { ToolBoxModel } from "../../webhook-interfaces/toolbox";


@Component({
    selector: 'webhook-toolbox',
    templateUrl: './webhook-edit-toolbox.component.html',
    styleUrl: './webhook-edit-toolbox.component.scss',
    standalone: false
})
export class WebhookEditToolboxComponent {

    closed = false;
    draggable = false;
    showMore = false;
    ctrol = 0;
    mouse = 0;
    index: number = 0;
    maxHeight: number = 0;

    constructor() {
        this.maxHeight = window.innerHeight - 120;
    }
    
    artefacts:ToolBoxModel[]= JSON.parse(localStorage.getItem('flow.toolbox.artefacts')) as ToolBoxModel[];
    connectors: ToolBoxModel[] = JSON.parse(localStorage.getItem('flow.toolbox.connector')) as ToolBoxModel[];
    


    public mouseDown(event: MouseEvent): void { 
        event.preventDefault();
        this.mouse = 1;
        if ( this.mouse == 1){
          this.draggable = true;
        }else{
          this.draggable = false;
        }
      }
    
      public mouseUp(event: MouseEvent): void { 
        event.preventDefault();
        this.mouse = 0;
        this.draggable = false;
      }
    
      close(){
        this.closed = !this.closed;
        if (this.closed) {
            this.showMore = false;
        }
      }
}